import React from 'react'

const UnderPar = () => {
    return (
        <div className="page-container col-sm-9">
            <p>
                List of players that had the most under par scores in each week of a season.
            </p>
            <span className="pagebanner">No Leaders found.</span>
            <table cellSpacing={0} id="user" className="table" cellPadding={0}>
                <thead>
                    <tr>
                        <th className="sortable sorted order1">
                            <a href="?d-49809-s=0&d-49809-o=1&id=24">
                                Seeson &amp; City Specific
                            </a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=1&d-49809-o=2&id=24">Last Name</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=2&d-49809-o=2&id=24">First Name</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=3&d-49809-o=2&id=24">Week 1</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=4&d-49809-o=2&id=24">Week 2</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=5&d-49809-o=2&id=24">Week 3</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=6&d-49809-o=2&id=24">Week 4</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=7&d-49809-o=2&id=24">Week 5</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=8&d-49809-o=2&id=24">Week 6</a>
                        </th>
                        <th className="sortable">
                            <a href="?d-49809-s=9&d-49809-o=2&id=24">
                                Total Birdie Points For The Season
                            </a>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="empty">
                        <td colSpan={10}>Nothing found to display.</td>
                    </tr>
                </tbody>
            </table>
        </div>

    )
}

export default UnderPar